//#region Imports
import {
  AlertBannerSummaryComponent, AlertSummaryComponent, ExpirationDateWarningComponent, IconsAndPillsFiltersComponent, IconsComponent, PaginationControlsComponent as ACPaginationControlsComponent,
  PasswordResetComponent, POKeyComponent, SpinnerComponent, StationIdleWarningComponent, StationTokenExpirationWarningComponent, StatusPillsComponent,
} from '@absg/angular-components';
import { AuthorizationModule } from '@absg/angular-platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'angular-calendar';
import { IMaskModule } from 'angular-imask';
import { NgxPaginationModule } from 'ngx-pagination';
import { CalendarPickerComponent } from 'shared.components/calendar-picker/calendar-picker.component';
import { GlobalNavigationComponent } from 'shared.components/global-navigation/global-navigation.component';
import { PageablePickListComponent } from 'shared.components/pageable-pick-list/pageable-pick-list.component';
import { BooleanRuleComponent } from 'shared.components/rules/boolean-rule/boolean-rule.component';
import { RuleContainerComponent } from 'shared.components/rules/rule-container/rule-container.component';
import {
  PaginationControlsForStaticTemplateComponent,
} from 'shared.root/components/pagination-controls-for-static-template/pagination-controls-for-static-template.component';
import { FocusDirective } from 'shared.root/directives/focus.directive';

import { AccessDeniedComponent } from '../main/accessdenied/access-denied.component';
import { ClearSearchInputComponent } from './components/clear-search-input/clear-search-input.component';
import { DateInputComponent } from './components/date-input/date-input.component';
import { ItemPillComponent } from './components/item-pill-component/item-pill.component';
import { KeypadComponent } from './components/keypad/keypad.component';
import { OrderTypeFilterComponent } from './components/order-type-filter/order-type-filter.component';
import { PaginationControlsComponent } from './components/pagination-controls/pagination-controls.component';
import { ReOpenDoorButtonComponent } from './components/reopen-access-point-button/reopen-access-point-button.component';
import { StationListUnderhoodComponent } from './components/station-list-underhood/station-list-underhood.component';
import { ContentTabComponent } from './components/tab-component/content-tab/content-tab.component';
import { TabbedContainerComponent } from './components/tab-component/tabbed-container/tabbed-container.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { TransferSubstituteComponent } from './components/transfer-substitute/transfer-substitute.component';
import { WitnessDiscrepancyComponent } from './components/witness/witness-discrepancy/witness-discrepancy.component';
import { WitnessLoginComponent } from './components/witness/witness-login/witness-login.component';
import { WitnessVerifyQOHComponent } from './components/witness/witness-verify-qoh/witness-verify-qoh.component';
import { TypeFocusDirective } from './directives/type-focus.directive';
import { DisplayToUserPipe } from './helpers/display-to-user.pipe';

//#endregion

@NgModule({
  imports: [
    CalendarModule,
    CommonModule,
    NgxPaginationModule,
    AuthorizationModule,
    FormsModule,
    ReactiveFormsModule,
    IMaskModule,
    SpinnerComponent,
    StatusPillsComponent,
    IconsComponent,
    IconsAndPillsFiltersComponent,
    POKeyComponent,
    PasswordResetComponent,
    ExpirationDateWarningComponent,
    ACPaginationControlsComponent,
    AlertBannerSummaryComponent,
    StationIdleWarningComponent,
    AlertSummaryComponent,
    StationTokenExpirationWarningComponent,
  ],
  declarations: [
    BooleanRuleComponent,
    CalendarPickerComponent,
    FocusDirective,
    GlobalNavigationComponent,
    KeypadComponent,
    PageablePickListComponent,
    PaginationControlsComponent,
    ReOpenDoorButtonComponent,
    RuleContainerComponent,
    TabbedContainerComponent,
    ContentTabComponent,
    TimePickerComponent,
    DateInputComponent,
    AccessDeniedComponent,
    PaginationControlsForStaticTemplateComponent,
    WitnessLoginComponent,
    WitnessVerifyQOHComponent,
    WitnessDiscrepancyComponent,
    DisplayToUserPipe,
    StationListUnderhoodComponent,
    TypeFocusDirective,
    TransferSubstituteComponent,
    ClearSearchInputComponent,
    ItemPillComponent,
    OrderTypeFilterComponent,
  ],
  exports: [
    AuthorizationModule,
    CalendarPickerComponent,
    FocusDirective,
    GlobalNavigationComponent,
    KeypadComponent,
    NgxPaginationModule,
    PageablePickListComponent,
    PaginationControlsComponent,
    TabbedContainerComponent,
    ReOpenDoorButtonComponent,
    ContentTabComponent,
    TimePickerComponent,
    DateInputComponent,
    AccessDeniedComponent,
    PaginationControlsForStaticTemplateComponent,
    WitnessLoginComponent,
    WitnessVerifyQOHComponent,
    WitnessDiscrepancyComponent,
    DisplayToUserPipe,
    StationListUnderhoodComponent,
    TypeFocusDirective,
    TransferSubstituteComponent,
    ClearSearchInputComponent,
    ItemPillComponent,
    OrderTypeFilterComponent,
    SpinnerComponent,
    StatusPillsComponent,
    IconsComponent,
    IconsAndPillsFiltersComponent,
    POKeyComponent,
    PasswordResetComponent,
    ExpirationDateWarningComponent,
    ACPaginationControlsComponent,
    AlertBannerSummaryComponent,
    StationIdleWarningComponent,
    AlertSummaryComponent,
    StationTokenExpirationWarningComponent,
  ],
})
export class SharedModule { }
